import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Popup } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { LogicCondition } from '@leverege/condition';
import I18N from '@leverege/i18n';
import { AttributeCondition } from '@leverege/ui-attributes';
import HistoryViewModel from "../../dataViewers/history/models/HistoryViewModel.js";
import HistoryConditionEditor from "../../dataViewers/history/editors/HistoryConditionEditor.js";
import ConditionFilterModels from "../../filters/filter/ConditionFilterModels.js";
import ConditionFilterModel from "../../filters/filter/ConditionFilterModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  tIcon,
  t
} = I18N.ns('molten.conditionFilter.HistoryConditionFilterActionRenderer');
export default function HistoryConditionFilterActionRenderer(props) {
  const {
    context
  } = props;
  const {
    clientProps
  } = context;
  const {
    settings,
    mobile,
    delegate,
    objectType,
    settingsData,
    relationship,
    onSettingsChange
  } = clientProps;
  const [opened, setOpened] = useState(false);
  const onPopupChange = useCallback(({
    isOpened
  }) => {
    setOpened(isOpened);
  }, [setOpened]);
  const condition = useMemo(() => {
    return HistoryViewModel.getCondition(settings) || ConditionFilterModels.getModelFor(delegate.type, objectType)?.create({
      rootCondition: LogicCondition.create({
        operator: 'and'
      })
    }) || null;
  }, [settings, delegate.type, objectType]);
  useEffect(() => {
    const onOpened = evt => {
      const ac = AttributeCondition.create({
        attrName: evt.detail?.attrName
      });
      const nConditionFilterModel = ConditionFilterModel?.addCondition(condition, ac);
      const nSettings = HistoryViewModel.setCondition(settings, nConditionFilterModel);
      onSettingsChange({
        data: settingsData,
        value: nSettings
      });
      setOpened(true);
    };
    window.addEventListener(`molten.filter.${objectType}.open`, onOpened);
    return () => {
      window.removeEventListener(`molten.filter.${objectType}.open`, onOpened);
    };
  }, [setOpened, condition, settings]);
  const onConditionChange = useValueChange(HistoryViewModel, {
    ...clientProps,
    eventData: settingsData,
    value: settings,
    onChange: onSettingsChange
  });
  return /*#__PURE__*/_jsx(Popup, {
    opened: opened,
    onChange: onPopupChange,
    variant: "filter",
    toggleVariant: mobile ? 'mobileFilter|mobileActionBar' : 'filter|sortFilterBar|actionBar',
    icon: tIcon('filterIcon'),
    title: t('name'),
    children: /*#__PURE__*/_jsx(HistoryConditionEditor, {
      onChange: onConditionChange,
      value: condition,
      delegate: delegate,
      objectType: objectType,
      eventData: "setCondition",
      relationship: relationship
    })
  });
}